/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Base from './base'
import URI from 'urijs'

// @namespace Model
class RegistrationInfo extends Base {
  url () {
    return URI('/api/users').segment(this.get('login')).segment('registration_info').toString()
  }

  participationCost () {
    return parseFloat(this.get('participation_cost'))
  }

  needsToPay () {
    return this.participationCost() > 0
  }

  isExistingParticipant () {
    return !!this.get('existing_participant')
  }

  /*
   * true if the presenter's account has self-registration enabled.
   * Will be true for nearly every account.
   */
  participantSelfRegistration () {
    return !!this.get('participant_self_registration')
  }

  register (params) {
    if (params == null) { params = {} }
    return this.save(params,
      { url: this.registerUrl() })
  }

  registerUrl () {
    return URI('register').setQuery('email', this.get('login')).toString()
  }
}

export default RegistrationInfo
